module.exports = __webpack_public_path__ + "img/18.b66e417d.png";